// ============================================================================
// MessageReactionsRow — чипы реакций сообщения (как в мессенджерах): только
// реакции с картинкой из ветки «Картинки» (SSoT — reactionPictures), группировка
// по коду с счётчиком и переключением. Вынесено из MessageBubble (SRP;
// бюджет строк файла); рендер-логика реакций НЕ дублируется.
// ============================================================================

import { ReactionGlyph } from '@/components/chat/ReactionGlyph';
import { isKnownReaction, reactionLabel } from '@/lib/reactionPictures';

export function groupReactions(reactions?: { emoji: string; userId: string }[]): { emoji: string; users: string[] }[] {
  const map = new Map<string, string[]>();
  for (const r of (reactions || [])) { const a = map.get(r.emoji) || []; a.push(r.userId); map.set(r.emoji, a); }
  return Array.from(map.entries()).map(([emoji, users]) => ({ emoji, users }));
}

interface Props {
  reactions?: { emoji: string; userId: string }[];
  myId: string;
  /** Версия картинок реакций (перерисовка, когда SVG доехали из «Картинок») */
  rxVersion: number;
  senderName: (id: string) => string;
  onToggle: (emoji: string) => void;
}

export function MessageReactionsRow({ reactions, myId, rxVersion, senderName, onToggle }: Props) {
  // НИКАКОГО ЛЕГАСИ: чипы только для ИЗВЕСТНЫХ реакций (реестр «Картинок»
  // либо встроенный fallback того же SSoT — reactionDisplay)
  const groups = groupReactions(reactions).filter((g) => isKnownReaction(g.emoji));
  if (groups.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5 mt-1.5" data-rx-version={rxVersion}>
      {groups.map((g) => {
        const mineReact = g.users.includes(myId);
        return (
          <button
            key={g.emoji}
            className={`flex items-center gap-1 px-2 py-1 rounded-full border transition-all hover:scale-110 ${mineReact
              ? 'bg-background border-primary/60'
              : 'bg-background border-border hover:border-primary/40'}`}
            onClick={() => onToggle(g.emoji)}
            title={`${reactionLabel(g.emoji)} · ${g.users.length} · ${g.users.map((u) => senderName(u)).join(', ')}`}
          >
            <ReactionGlyph value={g.emoji} size={16} />
            <span className={`text-[10px] font-semibold ${mineReact ? 'text-primary' : 'text-muted-foreground'}`}>{g.users.length}</span>
          </button>
        );
      })}
    </div>
  );
}
